export default __webpack_public_path__ + "static/media/sm_pink_bot.e10146b1.gif";